/* eslint-disable no-alert */ /* eslint-disable no-nested-ternary */
<template>
  <div class="cs-payment" />
</template>

<script>
import { SET_HOSTED_PAGE_INFO } from '@/store/modules/user/consts';
import helper from '@/utils/helper';
import { beginIframeCartLoading } from '@/utils/routeLoader';
import { getIntegrationLogQueryParams } from '@/utils/activityLogContext';

export default {
  name: "HostedPage",
  async mounted() {
    this.$nextTick(async () => {
      try {
        const hostedPageId = this.$route?.params?.id;
        if (!hostedPageId) {
          // In iframe without UUID, wait for parent postMessage cart payload.
          if (helper.isInIframe()) {
            return;
          }
          throw new Error("invalid order!");
        }
        beginIframeCartLoading();
        this.$store.dispatch(`user/${SET_HOSTED_PAGE_INFO}`, hostedPageId);
        const integrationParams = getIntegrationLogQueryParams({ hostedPageId });
        const resp = await this.$store.dispatch(`auth/getOrderDetails`, {
          id: hostedPageId,
          ...integrationParams,
        });
        this.inheritWhiteLabel(resp.whiteLabelInfo);
        this.setCartData(resp.hostedPageInfo);
      } catch (err) {
        console.log(err);
        this.$router.push({
          name: "404",
        });
      }
    });
  },
  methods: {
    inheritWhiteLabel(data) {
      // check if the iframe was whitelabeled
      if (data?.whitelabelStatus != 1) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = data.logo;
      }
    },
    setCartData(data) {
      let rfOrder = {};
      rfOrder = data;
      rfOrder.uuid = this.$route?.params?.id;
      rfOrder.token = data?.customerInfo?.rkflToken;
      rfOrder.merchantAuth = data?.customerInfo?.merchantAuth;
      window.EventBus.emit("rocketfuel_send_cart", rfOrder);
    },
  },
};
</script>

<style lang="scss" scoped></style>
